import React from "react";
import {Box, Stack} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import {styles} from '../Utilities/ProactiveMetricsDetailStyles';
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import {pageFilterToTitleMapper, linkMapper} from "../../MetricsDetail/MetricsDetailUtils";
import moduleStyles from "../Utilities/styles.module.css";
import { currentUser, queryStringToObject } from "_helpers";
import { userRoles } from "_constants";

export const HeaderLabel = ({ pageFilter }) => {
    const currentUserRole = currentUser && currentUser.roles && currentUser.roles[ 0 ];
    const isChatdeskAdmin = currentUser && currentUserRole === userRoles.CHATDESK_ADMIN_ROLE; 

    const search = location.search.substring(1);
    const filterParams = queryStringToObject(search);
    let { organizationId, startDate, endDate } = filterParams;

    const headerText = `Back to ${pageFilterToTitleMapper[pageFilter]}`;
    const link = isChatdeskAdmin ? `/admin/campaign?pageFilter=${pageFilter}&organizationId=${organizationId}&startDate=${startDate}&endDate=${endDate}` 
                                 : linkMapper[pageFilter]

    return (
        <Stack direction={'column'} className={moduleStyles.headerLabelStack}>
            <Box sx={{display: 'flex', justifyContent: 'flex-start'}}>
                <RouterLink to={link} className="tms-no-underline">
                    <Box sx={styles.backLink}>
                        <Box>
                          <ArrowBackIosNewIcon sx={styles.arrowBack}/>
                        </Box>
                        <Box className={moduleStyles.mt1}>{headerText}</Box>
                    </Box>
                </RouterLink>
            </Box>
        </Stack>
    )
}